import { CURRENT_SUB_MENU, SIGNIN_OUT, EXT_STATUS, HANGUP_CALL, CC_CALL_STATUS, TR_CC_CALL_STATUS, TR_CC_CLUDE_STATUS, TR_CC_CLUDE_STATUS_KICKOUT, CURRENT_TAB_ID } from '../mutation-types';
import { signOperate, getSingleExtStatus, hangup,callHangUp } from '../../api/callCenter';
import { CRM_MENU, CRM_CURRENT_SUBMENU, CRM_CURRENT_LEVEL_ONE_MENU, CRM_USER_INFO } from '../../util/keys';
import { doHanTianCall } from '../../util/util';
const state = {
    currentLevelOneId: 489,
    currentSubMenu: [],
    currentTabId: 0,
    extStatusId: 0,
    extStatusName: "",
    aliCallStatus: 0,
    trCCEventName: "",
    trCludeStatus: {
        state: '',
        stateAction: '',
        customerNumber: '',
    },
    kickOut: '',
};
const getters = {};
// 方法调用逻辑
const actions = {
    // 初始化一级菜单选中的ID
    initCurrentLevelOneId() {
        let id = localStorage.getItem(CRM_CURRENT_LEVEL_ONE_MENU);
        id && (state.currentLevelOneId = id);
    },
    // 更新二级菜单
    updateCurrentSubMenu({ commit, state }, nid) {
        let crmMenu = JSON.parse(localStorage.getItem(CRM_MENU));
        let subMenuId = nid || localStorage.getItem(CRM_CURRENT_LEVEL_ONE_MENU);
        for (var i in crmMenu) {
            if (crmMenu[i].NavigationId == subMenuId) {
                commit(CURRENT_SUB_MENU, crmMenu[i]);
                break;
            }
        }

    },
    updateCurrentTabId({ commit }, id) {
        commit(CURRENT_TAB_ID, id);
    },
    setCallStatus({ commit }, parmStatus) {
        commit(CC_CALL_STATUS, parmStatus);
    },
    updateTRCCStatus({ commit, state }, eventName) { //更新天润状态
        commit(TR_CC_CALL_STATUS, eventName);
    },
    updateTrCludeStatus({ commit, state }, status) {
        commit(TR_CC_CLUDE_STATUS, status);
    },
    updateKickOut({ commit, state }, status) {
        commit(TR_CC_CLUDE_STATUS_KICKOUT, status);
    },
    //右上角电话状态
    async signOperate({ commit }, parmSignInfo) {
        let ret = await signOperate(parmSignInfo);
        if (ret && ret.status === 0) {
            commit(SIGNIN_OUT, ret.result);
        } //获取签入状态
        let queryPrm = { ExtNo: parmSignInfo.ExtNo,UserNo:parmSignInfo.UserNo };
        let extInfo = await getSingleExtStatus(queryPrm);
        commit(EXT_STATUS, extInfo.result);
    },
    //呼出框
    async getExtStatus({ commit }, parmExtStatus) {
        let ret = await getSingleExtStatus(parmExtStatus);
        if (ret && ret.status === 0) {
            commit(EXT_STATUS, ret.result);
        }
    },
    async hangupCall({ commit }, parm) {
        let userInfo = JSON.parse(localStorage.getItem(CRM_USER_INFO));
        if (userInfo.CallCenterType == 2) {
            if (state.aliCallStatus === 6 ||
                state.aliCallStatus === 8 ||
                state.aliCallStatus === 9 ||
                state.aliCallStatus === 10) {
                window.workbench.hangUp();
            }
        } else if (userInfo.CallCenterType == 3) {
            if (state.trCludeStatus.state == "呼叫中" ||
                state.trCludeStatus.state == "响铃" ||
                state.trCludeStatus.state == "通话") {
                if (CTILink.Session.isSessionAlive()) {
                    switch (state.trCludeStatus.state) {
                        case '呼叫中':
                            CTILink.Session.previewOutcallCancel();
                            break;
                        case '响铃':
                            if (state.trCludeStatus.stateAction == 'ringingIb') {
                                CTILink.Session.refuse();
                            } else if (state.trCludeStatus.stateAction == 'ringingAgentOb') {
                                CTILink.Session.previewOutcallCancel();
                            }
                            break;
                        case '通话':
                        default:
                            CTILink.Session.unlink();
                            break;
                    }
                } else {
                    log("挂断失败，session不存在或已经销毁");
                }
            }
        } else if (userInfo.CallCenterType == 1) {
            let ret = await hangup(parm);
            if (ret && ret.status === 0) {
                commit(HANGUP_CALL, ret.result);
            }
        } else if (userInfo.CallCenterType == 4) {
            callHangUp({
                Dest: userInfo.HanTianCno,
                Cause:""
            });
            commit(TR_CC_CLUDE_STATUS, {state: "空闲",stateAction: 'idle', customerNumber: ''});
        }
    }
};
// 逻辑代码
const mutations = {
    /**
     * 更新当前一级菜单ID，二级菜单内容
     * @param state { Object }
     * @param ChildNavigations { Array } 二级菜单
     * @param NavigationId { Number } 一级菜单ID
     */
    [CURRENT_SUB_MENU](state, { ChildNavigations, NavigationId }) {
        state.currentSubMenu = ChildNavigations;
        state.currentLevelOneId = NavigationId;
        localStorage.setItem(CRM_CURRENT_SUBMENU, JSON.stringify(state.currentSubMenu));
        localStorage.setItem(CRM_CURRENT_LEVEL_ONE_MENU, state.currentLevelOneId)
    },
    [SIGNIN_OUT](state, recult) {

    },
    [CC_CALL_STATUS](state, recult) {
        state.aliCallStatus = recult;
    },
    [EXT_STATUS](state, result) {
        state.extStatusId = result.StatusId;
        state.extStatusName = result.Status;
    },
    [HANGUP_CALL](state, result) {

    },
    [TR_CC_CALL_STATUS](state, result) {
        state.trCCEventName = result;
    },
    [TR_CC_CLUDE_STATUS](state, result) {
        state.trCludeStatus.state = result.state;
        state.trCludeStatus.stateAction = result.stateAction;
        state.trCludeStatus.customerNumber = result.customerNumber;
    },
    [TR_CC_CLUDE_STATUS_KICKOUT](state, result) {
        state.kickOut = result
    },
    [CURRENT_TAB_ID](state, id) {
        state.currentTabId = id;
    }
};
export default {
    state,
    getters,
    actions,
    mutations
}